import React from "react";
import ByApplicationComp from "../../component/solutionscomponent/ByApplicationComp";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";

const ByApplication = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <ByApplicationComp />
        <Footer />
      </section>
    </>
  );
};

export default ByApplication;
